import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const RED = '#bf1e2e';

export default function EarlyPathwaysLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error: authError } = await supabase.auth.signInWithPassword({ email, password });
    if (authError) {
      setError('Invalid email or password.');
      setLoading(false);
      return;
    }

    navigate('/early-pathways');
  };

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '14px 16px', borderRadius: 10,
    border: '1px solid rgba(255,255,255,0.1)',
    background: 'rgba(255,255,255,0.05)',
    color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0f1a',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Barlow, sans-serif', padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img
            src="/bthd-email-sig-300x80-transparent.png"
            alt="Bigger Than Hoop Dreams"
            style={{ height: 36, width: 'auto', filter: 'brightness(0) invert(1)', marginBottom: 20 }}
          />
          <div style={{
            display: 'inline-flex', alignItems: 'center',
            background: 'rgba(191,30,46,0.08)', border: `1px solid ${RED}`,
            borderRadius: 30, padding: '6px 20px', marginBottom: 16,
          }}>
            <span style={{ fontFamily: 'Barlow Condensed, sans-serif', fontWeight: 700, fontSize: 13, color: RED, letterSpacing: 2 }}>EARLY PATHWAYS</span>
          </div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', marginTop: 6 }}>
            Sign in to continue your journey
          </div>
        </div>

        <div style={{ height: 3, borderRadius: 2, background: RED, marginBottom: 28 }} />

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 14 }}>
            <input
              type="email"
              placeholder="Parent, guardian or athlete email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              style={inputStyle}
            />
          </div>

          {error && (
            <div style={{ color: '#ff6b6b', fontSize: 13, marginBottom: 14, textAlign: 'center' }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '14px', borderRadius: 10,
              background: RED, border: 'none', color: '#fff',
              fontFamily: 'Barlow Condensed, sans-serif',
              fontWeight: 700, fontSize: 16, letterSpacing: 1, cursor: 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Signing in…' : 'SIGN IN'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 24, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <a href="/early-pathways/signup" style={{ fontSize: 13, color: RED, textDecoration: 'none' }}>
            New athlete? Create an account
          </a>
          <a href="/admin/login" style={{ fontSize: 13, color: 'rgba(255,255,255,0.25)', textDecoration: 'none' }}>
            ← Back to portal selection
          </a>
        </div>
      </div>
    </div>
  );
}
